module.exports = __webpack_public_path__ + "static/img/part-exampel-bg-01.e35b60b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/part-exampel-bg-01.jpg
// module id = cAbs
// module chunks = 7